import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { NavLink, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import ACL from '@components/ACL'
import DeleteIcon from '@components/Icon/Delete'
import EditIcon from '@components/Icon/Edit'
import { showDialog, isCancellationError } from '@components/Dialog'

class InvoicingTable extends Component {
  static propTypes = {
    invoicingEntities: PropTypes.object,
    invoicingEntitiesStore: PropTypes.object,
    modalStore: PropTypes.object,
    baseUrl: PropTypes.string,
    growlStore: PropTypes.object
  }

  deleteInvoiceEntity = (invoiceId, legalName) => {
    const { invoicingEntitiesStore, growlStore } = this.props
    return showDialog({
      title: 'Delete this invoicing entity?',
      text: legalName,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(() => {
        return invoicingEntitiesStore.deleteInvoicingEntity(invoiceId)
      })
      .catch(err => {
        if (isCancellationError(err)) return
        growlStore.showError(
          err,
          `Couldn't delete invoicing entity ${legalName}`
        )
      })
  }

  renderInvoiceDeleteAction = invoice => {
    if (!invoice.invoices) return null
    if (invoice.invoices.length) return null

    return (
      <span
        className='right clickable'
        onClick={() => this.deleteInvoiceEntity(invoice.id, invoice.legalName)}
      >
        {invoice.invoices.length ? '' : <DeleteIcon />}
      </span>
    )
  }

  renderInvoicingTable (invoicingEntities) {
    const { projectIdToUpdate } = Object.fromEntries(new URLSearchParams(this.props.location.search)) ?? null
    const getInvoicingEntityLink = (invoiceId) => {
      if (projectIdToUpdate) {
        return this.props.baseUrl + `/${invoiceId}?projectIdToUpdate=${projectIdToUpdate}`
      }

      return this.props.baseUrl + `/${invoiceId}`
    } 
    const { loadInvoicingEntities } = this.props.invoicingEntitiesStore
    return (
      <table className='table-wrapper invoice-table invoicing'>
        <thead>
          <tr>
            <th>Invoicing entity legal name</th>
            <th>GL code</th>
            <th>Country</th>
            <th />
          </tr>
        </thead>
        {invoicingEntities.map(invoice => {
          return (
            <tbody key={invoice.id}>
              <tr>
                <td>
                  <NavLink to={getInvoicingEntityLink(invoice.id)}>
                    {invoice.legalName}
                  </NavLink>
                </td>
                <td>
                  <span className='text-wrapper'>{invoice.glCode}</span>
                </td>
                <td>
                  <span className='text-wrapper'>{invoice.country}</span>
                </td>
                <td>
                  <span
                    className='clickable'
                    onClick={() => {
                      return this.props.modalStore.show({
                        type: 'INVOICING_ENTITY_FORM',
                        props: {
                          invoicingEntity: invoice,
                          parentAccount: invoice.parentAccount,
                          onSaveSuccess: invoicingEntity => {
                            loadInvoicingEntities(
                              invoicingEntity.parentAccountId
                            )

                            this.props.growlStore.showSuccess(
                              `${invoicingEntity.legalName} successfully saved.`
                            )

                            this.props.modalStore.close()
                          }
                        }
                      })
                    }}
                  >
                    <EditIcon />
                  </span>
                  <ACL inline roles={['Admin', 'Accounting']}>
                    {this.renderInvoiceDeleteAction(invoice)}
                  </ACL>
                </td>
              </tr>
            </tbody>
          )
        })}
      </table>
    )
  }

  render () {
    const { invoicingEntities } = this.props.invoicingEntitiesStore
    return this.renderInvoicingTable(invoicingEntities)
  }
}

export default withRouter(
  inject('modalStore', 'growlStore')(observer(InvoicingTable))
)
